// extracted by mini-css-extract-plugin
export var fadePop = "Footnote-module--fade-pop--e07ef";
export var footnote = "Footnote-module--footnote--736c0";
export var growHeightIn = "Footnote-module--grow-height-in--3bf1a";
export var toggleFootnote = "Footnote-module--toggleFootnote--d3185";